/**
 * Get current node height based
 */
export const getNodeHeight = (node: HTMLDivElement) => {
  const { bottom, top } = node.getBoundingClientRect()
  const height = bottom - top
  return height
}

/**
 * Set node style.height in pixel
 */
export const setNodeHeightStyles = (
  node: HTMLDivElement,
  { height }: { height: number }
) => {
  node.style.height = `${height}px`
}

/**
 * Reset node style.height to initial
 */
export const setNodeInitialHeightStyles = (node: HTMLDivElement) => {
  node.style.height = `initial`
}
